module.exports = __webpack_public_path__ + "static/media/IMG-20180728-WA0172.3ba87912.jpg";